import { useTranslation } from "../i18n";
import "./UpgradeNudge.css";

const UPGRADE_MAP = {
  free: { nextPlan: "Starter", nextLimit: 4, limit: 0 },
  starter: { nextPlan: "Pro", nextLimit: 6, limit: 4 },
};

export default function UpgradeNudge({ currentPlan, onUpgrade, onDismiss, loading }) {
  const { t } = useTranslation();
  const info = UPGRADE_MAP[currentPlan];

  if (!info) return null;

  const planName = currentPlan.charAt(0).toUpperCase() + currentPlan.slice(1);

  return (
    <div className="un-banner" role="alert">
      <div className="un-icon" aria-hidden="true">⚠</div>

      <div className="un-body">
        <p className="un-message">
          {t("subscription.limitReached", { plan: planName, limit: info.limit })}
        </p>
        <p className="un-message un-message--secondary">
          {t("subscription.upgradePrompt", { nextPlan: info.nextPlan, nextLimit: info.nextLimit })}
        </p>
      </div>

      <div className="un-actions">
        <button
          className="btn-primary btn-sm"
          onClick={onUpgrade}
          disabled={loading}
        >
          {loading && <span className="un-spinner" />}
          {t("subscription.upgrade")}
        </button>
        <button
          className="btn-ghost btn-sm"
          onClick={onDismiss}
        >
          {t("subscription.maybeLater")}
        </button>
      </div>
    </div>
  );
}
